import LongFormArticleTemplate from '@/components/LongFormArticleTemplate';
import { nycPages } from '@/data/nycPages';

export default function NycWhatIsTheLookBackPeriodInNewYorkPage() {
  return <LongFormArticleTemplate page={nycPages['/nyc-what-is-the-look-back-period-in-new-york/']} />;
}
